<div class="modal-header border-b border-solid border-base-2 px-6 py-4">
    <h2
        class="modal-title text-title-2 text-text-primary font-semibold"
        id="location-error-dialog-title"
        translate="error.location.title"
    ></h2>
    <button
        type="button"
        class="btn btn-circle btn-ghost element-cancel"
        [attr.aria-label]="'accessibility.close-dialog' | translate"
        (click)="onAccept()"
    ></button>
</div>
<div class="modal-body px-6 py-5">
    <p class="mb-0 text-base leading-6 text-text-primary" translate="error.location.body"></p>
</div>
<div class="modal-footer border-t border-solid border-base-2 px-6 py-4">
    <button
        type="button"
        class="btn btn-primary"
        [attr.aria-label]="'error.location.accept' | translate"
        (click)="onAccept()"
    >
        <span translate="error.location.accept"></span>
    </button>
</div>
